<template>
    <div class="not-found">
        <div class="not-found__container">
            <h1>Not found <span>:(</span></h1>
            <p>Sorry, but the page you were trying to view does not exist.</p>
            <p>It looks like this was the result of either:</p>
            <ul>
                <li>a mistyped address</li>
                <li>an out-of-date link</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'not-found',
};
</script>

<style lang="scss">
.not-found {
    height: 100%;
    padding: 50px 10px;
    background: #f0f0f0;

    &__container {
        max-width: 500px;
        padding: 30px 20px;
        border: 1px solid #b3b3b3;
        border-radius: 4px;
        margin: 0 auto;
        box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;
        background: #fcfcfc;

        h1 {
            font-size: 50px;
            text-align: center;

            span {
                color: #bbb;
            }
        }
    }
}
</style>
